import Pagination from '@mui/material/Pagination';
import { requestContacts, setPage } from '../../../../store/conversationGrid';
import { useAppDispatch, useAppSelector } from '../../../../store/hooks';

export default function TablePagination() {
    const dispatch = useAppDispatch();

    const page = useAppSelector(state => state.conversationGrid.page);

    const pageCount = useAppSelector(state => state.conversationGrid.pageCount);

    const handleChange = (e: any, value: number) => {
        dispatch(setPage({ page: value - 1 }));
        dispatch(requestContacts());
    };

    return (
        <Pagination
            color="primary"
            size="small"
            page={page + 1}
            count={pageCount}
            onChange={handleChange}
        />
    );
}
